import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { ToolEnum } from 'src/Models/Common';
import { FilterModel } from 'src/Models/filterModel';
import { TaxExemptionFormModel } from 'src/Models/TaxExemptionFormsModel';
import { CheckAuth } from 'src/Services/utility.service';
import { TaxExemptionFormsServiceService } from 'src/Services/tax-exemption-forms-service.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-tax-exemption-form',
  templateUrl: './tax-exemption-form.component.html',
  styleUrls: ['./tax-exemption-form.component.css']
})
export class TaxExemptionFormComponent implements OnInit {
  filterModel = new FilterModel();
  currentPage: number = 1;
  totalRecordCount: number = -1;

  listOfGetTaxExemptionFormData: TaxExemptionFormModel[];

  isUserSystemAdmin: boolean = true;
  tokenKey: string = '';
  SelectedTool: string;

  isAscending: boolean = false
  upDowTitleCSS: string = '';
  upDowURLCSS: string = '';
  upDowIsActiveCSS: string = '';
  upDowIsIsAllowallAccessCSS: string = '';
  upDowCreatedDateCSS: string = '';
  upDowModifiedDateCSS: string = '';
  upDowSortOrderCSS: string = '';
  upDowSectionCSS: string = '';

  productId: number = 1;
  deletedId: number = 0;
  isloading: boolean;
  taxExemptionFormId: number = 0;
  selectedItemsStatus = [];
  selectedItemsFree = [];
  dropdownSettingsStatus = {};
  dropdownSettingsFree = {};
  listOfStatus = [];
  statusId: string = ' ';
  listOfFree = [];
  freeId: string = ' ';
  moduleList: any[] = [{ itemName: 'Yes', id: '1' }, { itemName: 'No', id: '0' }];
  dropdownListSection = [];
  dropdownSettingsSections = {};
  selectedItemsSections = [];
  listOfSectionID: string[] = [];
  selectedItemsSection = [];
  listOfSection?: string;
  PageNumber: number;

  constructor(private readonly activedRoute: ActivatedRoute,
    private readonly tefService: TaxExemptionFormsServiceService,
    private readonly router: Router,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.productId = ToolEnum[this.SelectedTool];
    this.titleService.setTitle('Tax Exemption Forms');
    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '10';
    this.filterModel.orderBy = 'SortOrder';

  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.dropdownSettingsSections = {
      singleSelection: true,
      text: "Filter by Sections",
      enableSearchFilter: true,
      classes: 'borderLessTextBoxGreen',
      noDataLabel: 'No Section available',
    };
    this.dropdownSettingsStatus = {
      singleSelection: true,
      text: "Filter by Active",
      enableSearchFilter: false,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No record available',
      showCheckbox: false
    };
    this.dropdownSettingsFree = {
      singleSelection: true,
      text: "Filter by Free",
      enableSearchFilter: false,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No record available',
      showCheckbox: false
    };

    this.activedRoute.params.subscribe((params: Params) => {
      if (params['id']) {
        if (params['id'] != null) {

          this.taxExemptionFormId = params['id'];
          this.GetTaxExemptionFormData();
        }
      }
    });
    this.GetTaxExemptionFormData();
    this.getAllSections();

  }


  GetTaxExemptionFormData() {
    this.listOfGetTaxExemptionFormData = [];
    this.isloading = true;
    this.tefService.i360TaxExemptionFormsGet(this.tokenKey, this.filterModel).subscribe(
      data => {
        this.isloading = false;
        if (data != null) {
          this.listOfGetTaxExemptionFormData = data['taxExemptionFormData'];
          if (this.listOfGetTaxExemptionFormData != null) {
            if (this.listOfGetTaxExemptionFormData.length > 0) {
              this.totalRecordCount = this.listOfGetTaxExemptionFormData[0].totalRecordCount;
            }
            else {
              this.totalRecordCount = 0;
            }
          }
          else {
            this.totalRecordCount = 0;
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  keywordFilters($event) {
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    if ($event.target.value != "" && $event.target.value != null) {
      this.filterModel.whereCondition = $event.target.value;
    }
    else {
      this.filterModel.whereCondition = '';
    }
    this.GetTaxExemptionFormData();
  }

  pageChanged($event: any) {
    this.currentPage = $event.page;
    this.filterModel.pageNumber = parseInt($event.page).toString();
    this.GetTaxExemptionFormData();
  }

  cleanCssClass() {
    this.upDowTitleCSS = '';
    this.upDowIsActiveCSS = '';
    this.upDowIsIsAllowallAccessCSS = '';
    this.upDowCreatedDateCSS = '';
    this.upDowModifiedDateCSS = '';
    this.upDowSectionCSS = '';

  }

  sort(sortBy: any) {
    this.cleanCssClass();
    this.isAscending = !this.isAscending;
    this.filterModel.orderBy = this.isAscending ? sortBy : sortBy + ' DESC';

    switch (sortBy) {
      case "title": this.upDowTitleCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
      case "isActive": this.upDowIsActiveCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
      case "isAllowallAccess": this.upDowIsIsAllowallAccessCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
      case "CreatedDate": this.upDowCreatedDateCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
      case "ModifiedDate": this.upDowModifiedDateCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
      case "sortOrder": this.upDowSortOrderCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
      case "sectionName": this.upDowSectionCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;

      default: break;
    }
    this.GetTaxExemptionFormData();
  }

  addTaxExemptionForms() {
    this.router.navigate(['admin/jsi360/Manage/TaxExemptionForms']);
  }

  editData(id) {
    this.router.navigate(['admin/jsi360/Manage/TaxExemptionForms/' + id])
  }

  setDeleteData(ids) {
    this.deletedId = ids;
  }

  deleteRecord(deletedId) {
    this.tefService.i360TaxExemptionFormDelete(this.tokenKey, deletedId).subscribe(
      data => {
        this.deletedId = 0;
        if (data != null) {
          if (data['deletedId'] > 0) {
            this.GetTaxExemptionFormData();
            this.toastr.success('Record deleted successfully.', 'Delete')
          }
        }
      },
      error => {
      }
    );
  }

  drop(event: CdkDragDrop<string[]>): void {
    var CurrentShortOrder, PreviousShortOrder, currentcustomProductDetailsId, previouscustomProductDetailsId
    PreviousShortOrder = this.listOfGetTaxExemptionFormData[event.previousIndex]['sortOrder']
    previouscustomProductDetailsId = this.listOfGetTaxExemptionFormData[event.previousIndex]['taxExemptionFormId']

    CurrentShortOrder = this.listOfGetTaxExemptionFormData[event.currentIndex]['sortOrder']
    currentcustomProductDetailsId = this.listOfGetTaxExemptionFormData[event.currentIndex]['taxExemptionFormId']

    this.tefService.i360TaxExemptionFormUpdate(this.tokenKey, previouscustomProductDetailsId, currentcustomProductDetailsId).subscribe(
      data => {
        this.deletedId = 0;
        if (data != null) {
          this.tefService.i360TaxExemptionFormsGet(this.tokenKey, this.filterModel).subscribe(
            data => {
              this.isloading = false;
              if (data != null) {
                this.listOfGetTaxExemptionFormData = data['taxExemptionFormData'];
                if (this.listOfGetTaxExemptionFormData != null) {
                  if (this.listOfGetTaxExemptionFormData.length > 0) {
                    this.totalRecordCount = this.listOfGetTaxExemptionFormData[0].totalRecordCount;
                  }
                  else {
                    this.totalRecordCount = 0;
                  }
                }
                else {
                  this.totalRecordCount = 0;
                }
              }
            },
            error => {
              this.isloading = false;
              console.log(error);
            })
        }
      },
      error => {
      }
    );

  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  getAllSections() {
    this.tefService.i360TaxExemptionFormsSectionListWithIds(this.tokenKey).subscribe(data => {
      if (data['status'] !== 'Failure') {
        for (let iCounter = 0; iCounter < data['sectionList'].length; iCounter++) {
          this.dropdownListSection.push(
            { 'id': data['sectionList'][iCounter].sectionId, 'itemName': data['sectionList'][iCounter].sectionName }
          );
        }
        if (this.listOfSectionID != null && this.listOfSectionID != undefined) {
          for (let iCounter = 0; iCounter < this.listOfSectionID.length; iCounter++) {
            if (this.listOfSectionID[iCounter] != '') {
              let obj = data["sectionList"].filter(m => m.productId == this.listOfSectionID[iCounter]);
              if (obj != null) {
                this.selectedItemsSection.push({ "id": obj[0].sectionId, "itemName": obj[0].sectionName });
              }
            }
          }
        }

      }
    });
  }

  onSelectStatus($event) {
    this.listOfStatus = this.removeElemetninArray(this.listOfStatus, $event.id)
    this.listOfStatus.push($event.id);
    this.statusId = ' ';
    if (this.listOfStatus.length > 0) {
      this.statusId = $event.id;
      this.filterModel.statusId = this.statusId;
    } else {
      this.filterModel.statusId = null;
    }

    this.GetTaxExemptionFormData();
  }

  onDeSelectStatus($event) {
    if (this.listOfStatus != null) {
      if (this.listOfStatus.length > 0) {
        this.listOfStatus = this.removeElemetninArray(this.listOfStatus, $event.id)
      }
    }
    this.statusId = '';
    if (this.listOfStatus.length > 0) {
      this.statusId = $event.id;
    }
    this.filterModel.statusId = null;
    this.GetTaxExemptionFormData();
  }

  onDeSelectAllStatus($event) {
    this.statusId = '';
    this.listOfStatus = [];
    this.filterModel.statusId = null;
    this.GetTaxExemptionFormData();
  }

  onSelectFree($event) {
    this.listOfFree = this.removeElemetninArray(this.listOfFree, $event.id)
    this.listOfFree.push($event.id);
    this.freeId = ' ';
    if (this.listOfFree.length > 0) {
      this.freeId = $event.id;
      this.filterModel.freeId = this.freeId;
    }
    else {
      this.filterModel.freeId = null;
    }
    this.GetTaxExemptionFormData();
  }

  onDeSelectFree($event) {
    if (this.listOfFree != null) {
      if (this.listOfFree.length > 0) {
        this.listOfFree = this.removeElemetninArray(this.listOfFree, $event.id)
      }
    }
    this.freeId = '';
    if (this.listOfFree.length > 0) {
      this.freeId = $event.id;
    }
    this.filterModel.freeId = null;
    this.GetTaxExemptionFormData();
  }

  onDeSelectAllFree($event) {
    this.freeId = '';
    this.listOfFree = [];
    this.filterModel.freeId = null;
    this.GetTaxExemptionFormData();
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }

  onSelect($event) {
    this.PageNumber = 1;
    if (this.listOfSectionID != null) {
      this.listOfSectionID = [];
      if (this.listOfSectionID.length > 0) {
        this.listOfSectionID = this.removeElemetninArray(this.listOfSectionID, $event.id)
        this.listOfSectionID.push($event.id);
      }
      else {
        this.listOfSectionID.push($event.id);
      }
    }

    this.listOfSection = this.listOfSectionID.join(',');
    this.filterModel.section = this.listOfSection;
    this.GetTaxExemptionFormData();
  }

  onSelectAll($event) {
    this.PageNumber = 1;
    for (const item of $event) {
      if (this.listOfSectionID != null) {
        if (this.listOfSectionID.length > 0) {
          this.listOfSectionID = this.removeElemetninArray(this.listOfSectionID, item.id)
          this.listOfSectionID.push(item.id);
        }
        else {
          this.listOfSectionID.push(item.id);
        }
      }
    }
    this.listOfSection = this.listOfSectionID.join(',');
    this.filterModel.section = this.listOfSection;
    this.GetTaxExemptionFormData();
  }

  onDeSelectAll($event) {
    this.PageNumber = 1;
    this.listOfSectionID = [];
    this.listOfSection = '';
    this.filterModel.section = this.listOfSection;
    this.GetTaxExemptionFormData();
  }

  onDeSelect($event) {
    this.PageNumber = 1;
    if (this.listOfSectionID != null) {
      if (this.listOfSectionID.length > 0) {
        this.listOfSectionID = this.removeElemetninArray(this.listOfSectionID, $event.id)
      }
    }
    this.listOfSection = this.listOfSectionID.join(',');
    this.filterModel.section = this.listOfSection;
    this.GetTaxExemptionFormData();
  }

}
